import React, { useState } from 'react';
import { FlexRow, Heading, Button, DropdownList, FlexColumn } from '@forecast-it/design-system';
import ChangeViewButton from '../../forecast-app/shared/components/changeview/ChangeViewButton';
import { useEyeOptions } from '../../forecast-app/shared/hooks/useEyeOptions';
import { MODAL_TYPE, showModal } from '../../forecast-app/shared/components/modals/generic_modal_conductor';
import { PhaseCard } from './PhaseDeliverablesCard';
import Styled from 'styled-components/macro';
import CustomScrollDiv from '../../forecast-app/shared/components/scroll-bars/custom_scroll_div';
import { getInitialBaselineItems } from './Util';
const DeliverablesPhasesSectionWrapper = Styled.div `
	padding: 0 32px;
`;
const StyledHeaderRow = Styled.div `
	padding: 8px 0;
`;
export const PHASE_COLUMNS = {
    TIME_ESTIMATES: 'time_estimates',
    EXPENSE_ESTIMATES: 'expense_estimates',
    VALUE_OF_SERVICE: 'value_of_service',
    REVENUE: 'revenue',
    COST: 'cost',
    MARKUP: 'markup',
    PROFIT: 'profit',
    MARGIN: 'margin',
    RATE_PER_HOUR: 'rate_per_hour',
    COST_PER_HOUR: 'cost_per_hour',
};
const TIME_ESTIMATES_COLUMNS = [
    PHASE_COLUMNS.VALUE_OF_SERVICE,
    PHASE_COLUMNS.REVENUE,
    PHASE_COLUMNS.COST,
    PHASE_COLUMNS.PROFIT,
    PHASE_COLUMNS.RATE_PER_HOUR,
    PHASE_COLUMNS.COST_PER_HOUR,
];
const EXPENSE_ESTIMATES_COLUMNS = [
    PHASE_COLUMNS.REVENUE,
    PHASE_COLUMNS.COST,
    PHASE_COLUMNS.MARKUP,
    PHASE_COLUMNS.PROFIT,
    PHASE_COLUMNS.MARGIN,
];
const EYE_OPTION_COLUMNS = [
    { id: PHASE_COLUMNS.TIME_ESTIMATES, nestedOptions: TIME_ESTIMATES_COLUMNS },
    { id: PHASE_COLUMNS.EXPENSE_ESTIMATES, nestedOptions: EXPENSE_ESTIMATES_COLUMNS },
];
const PHASE_EYE_OPTIONS = EYE_OPTION_COLUMNS.map(column => ({
    name: column.id,
    translationId: 'phase_management.column.' + column.id,
    disabled: false,
    checked: true,
    nestedOptions: column.nestedOptions.map(nestedColumn => ({
        name: nestedColumn,
        translationId: 'phase_management.column.' + nestedColumn,
        disabled: false,
        checked: true,
    })),
}));
export const DeliverablesPhasesSection = ({ intl, project, company }) => {
    var _a, _b;
    const phases = (_a = project === null || project === void 0 ? void 0 : project.phases) === null || _a === void 0 ? void 0 : _a.edges;
    const baselineItems = getInitialBaselineItems(((_b = project === null || project === void 0 ? void 0 : project.phases) === null || _b === void 0 ? void 0 : _b.edges) || []);
    const currency = ((project === null || project === void 0 ? void 0 : project.rateCard) ? project === null || project === void 0 ? void 0 : project.rateCard.currency : company === null || company === void 0 ? void 0 : company.currency) || '';
    const placeholderContextMenuOptions = [
        {
            name: 'option 1',
            onClick: () => {
                return;
            },
        },
        {
            name: 'option 2',
            onClick: () => {
                return;
            },
        },
        {
            name: 'option 3',
            onClick: () => {
                return;
            },
        },
    ];
    const EYE_OPTIONS_LOCALSTORAGE_KEY = 'phase-management-eye-options';
    const [eyeOptionMap, setEyeOptionMap] = useState();
    const [, , eyeOptions, handleEyeOptionsChange] = useEyeOptions(PHASE_EYE_OPTIONS, EYE_OPTIONS_LOCALSTORAGE_KEY, undefined, setEyeOptionMap);
    const openShowHideColumnsModal = () => {
        showModal({
            type: MODAL_TYPE.SHOW_HIDE_COLUMNS,
            eyeOptions,
            onEyeOptionsChange: handleEyeOptionsChange,
        });
    };
    return (React.createElement(CustomScrollDiv, { horizontalcontent: true },
        React.createElement(DeliverablesPhasesSectionWrapper, null,
            React.createElement(StyledHeaderRow, null,
                React.createElement(FlexRow, { justifyContent: 'space-between', gap: 's' },
                    React.createElement(Heading, { size: 4 }, intl.formatMessage({ id: 'baseline.work_items' })),
                    React.createElement(FlexRow, { justifyContent: 'flex-end' },
                        React.createElement(Button, { emphasis: 'medium', icon: 'download', rightIcon: 'chevronDown', onClick: () => {
                                return undefined;
                            }, "data-cy": 'export-expenses-csv' }),
                        React.createElement(ChangeViewButton, null,
                            React.createElement(DropdownList.ContentGroup, { title: intl.formatMessage({ id: 'change_view.table_visibility' }) },
                                React.createElement(DropdownList.Item, { onClick: openShowHideColumnsModal }, intl.formatMessage({ id: 'change_view.show_hide_columns' })))),
                        React.createElement(Button, { emphasis: 'high', rightIcon: 'chevronDown', onClick: () => {
                                return null;
                            }, "data-cy": 'export-phases' }, intl.formatMessage({ id: 'baseline.edit_baseline.title' }))))),
            React.createElement(FlexColumn, { gap: "m" }, phases === null || phases === void 0 ? void 0 : phases.map(phaseEdge => {
                if (phaseEdge && phaseEdge.node && company) {
                    const phase = phaseEdge.node;
                    const items = baselineItems
                        .filter(item => item.phaseId === phase.id)
                        .map((item, index) => (Object.assign(Object.assign({}, item), { index })));
                    return (React.createElement(PhaseCard, { phase: phase, currency: currency, contextMenuOptions: placeholderContextMenuOptions, company: company, baselineItems: items, eyeOptionMap: eyeOptionMap }));
                }
                return null;
            }).filter(Boolean)))));
};
